// owned by WP-SEC-UI · the 10-hour limit (security §3.3, shell-ia §11.2): a non-blocking notice under the top bar at T − 10 min and
// again at T − 2 min, "Your session ends at 07:14 GST. Save your work; you will need to sign in again." It cannot be extended.
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Clock } from "lucide-react";
import { useAuth, useSessionClock } from "@ncp/api-client";
import { useLocale, useTranslation } from "@ncp/i18n";
import { formatTimeGst } from "../lib/time";

const FIRST_MS = 10 * 60_000;
const SECOND_MS = 2 * 60_000;

export function AbsoluteNotice() {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const { managed } = useAuth();
  const { absoluteDeadline } = useSessionClock();
  const [now, setNow] = useState(() => Date.now());
  const [dismissed, setDismissed] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 5_000);
    return () => window.clearInterval(timer);
  }, []);

  if (!managed || absoluteDeadline === null) return null;
  const left = absoluteDeadline - now;
  const phase = left <= 0 ? 0 : left <= SECOND_MS ? 2 : left <= FIRST_MS ? 1 : 0;
  if (phase === 0 || dismissed >= phase) return null;
  const time = formatTimeGst(absoluteDeadline, locale);

  return createPortal(
    <div
      role="status"
      aria-live="polite"
      data-session-warning="absolute"
      className="fixed inset-x-0 z-[65] mx-auto flex w-fit max-w-[calc(100vw-32px)] items-center gap-3 rounded-[var(--r-lg)] px-3 py-2 shadow-[var(--shadow-pop)]"
      style={{ top: "calc(var(--econic-chrome-top, 110px) + 8px)", background: "var(--st-warn-bg)", color: "var(--label)" }}
    >
      <Clock className="size-4 shrink-0" style={{ color: "var(--st-warn)" }} aria-hidden strokeWidth={1.75} />
      <span className="t-ui min-w-0">{t("assistant:econic.session.absolute.body", { time })}</span>
      <button type="button" className="ec-btn ghost sm" onClick={() => setDismissed(phase)}>{t("assistant:econic.session.absolute.dismiss")}</button>
    </div>,
    document.body,
  );
}
